/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { DialogWrapper } from "../common/dialogWrapper";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { ButtonWrapper } from "../formUtilities/useButton";
import { getToken } from "../../../services/authService";
import { LocalStorageKey } from "../../../constants/localStorageKeys";
import { decodeToken } from "react-jwt";
import { TextWrapper } from "../formUtilities/useTextWrapper";

export const TokenExpiryWarningDialog = () => {
  const [open, setOpen] = useState(false);
  const intervalRef = useRef(null);

  const { t } = useTranslation();
  const token = getToken();


  useEffect(() => {
    let alreadyClosed = localStorage.getItem(LocalStorageKey.tokenExpiring) === "1";
    if (!alreadyClosed) {
      checkTokenExpiry();
    }
  }, []);

  const checkTokenExpiry = () => {
    intervalRef.current = setInterval(() => {
      const decodedToken = decodeToken(token);
      if (!decodedToken) {
        onClearInterval();
        return;
      }
      const currentTime = Math.floor(Date.now() / 1000);
      const expiryTime = decodedToken.exp;
      const timeLeft = expiryTime - currentTime;
      if (timeLeft > 0 && timeLeft <= 35) {
        setOpen(true);
        onClearInterval();
        console.log("The token will expire within 30 seconds.");
      }
    }, 5000);
  };

  const onClose = (e) => {
    localStorage.setItem(LocalStorageKey.tokenExpiring, "1");
    onClearInterval();
    setOpen(false);
  };

  const onClearInterval = () => {
    if (intervalRef?.current) {
      clearInterval(intervalRef.current);
    }
  };

  return <DialogWrapper
    maxWidth="xs"
    centerHeading={true}
    state={open}
    preventOutsideClick={true}
    onClose={() => {
      onClose(false);
    }}
    title={t('warning')}
    subTitleClass="!font-normal !text-black"
    actionFooterClass="!px-0"
    content={
      <Box className="text-center">
        <TextWrapper classList="!text-center" text={t('tokenExpiryText')} />
      </Box>
    }
    actions={<ButtonWrapper onClick={() => { onClose(true); }} label={t('close')} />}></DialogWrapper>;
};